import axios from "axios";
import { API } from "./api";

const pinKey = (slug) => `c7_admin_pin_${slug || "_default"}`;

export const getAdminPin = (slug) => localStorage.getItem(pinKey(slug)) || "";
export const setAdminPin = (slug, pin) => localStorage.setItem(pinKey(slug), pin);
export const clearAdminPin = (slug) => localStorage.removeItem(pinKey(slug));

export const buildAdminApi = (slug) => {
    const instance = axios.create({ baseURL: `${API}/t/${slug}` });
    instance.interceptors.request.use((config) => {
        const pin = getAdminPin(slug);
        if (pin) config.headers["X-Admin-PIN"] = pin;
        return config;
    });
    return instance;
};

export const adminLogin = async (slug, pin) => {
    const r = await axios.post(`${API}/t/${slug}/admin/login`, { pin });
    if (r.data?.ok) setAdminPin(slug, pin);
    return r.data;
};

// ============ SUPER ADMIN ============

const SUPER_PIN_KEY = "c7_super_pin";
export const getSuperPin = () => localStorage.getItem(SUPER_PIN_KEY) || "";
export const setSuperPin = (pin) => localStorage.setItem(SUPER_PIN_KEY, pin);
export const clearSuperPin = () => localStorage.removeItem(SUPER_PIN_KEY);

export const superApi = axios.create({ baseURL: API });
superApi.interceptors.request.use((config) => {
    const pin = getSuperPin();
    if (pin) config.headers["X-Super-Admin-PIN"] = pin;
    return config;
});

export const superLogin = async (pin) => {
    const r = await axios.post(`${API}/super/login`, { pin });
    if (r.data?.ok) setSuperPin(pin);
    return r.data;
};
